import React, { useEffect, useState } from "react";
import useStyles from "../style";
import { renderErrorCreatePool } from "../../../utils/validate";

function TokenPriceGiveaway(props: any) {
  const classes = useStyles();
  const { register, errors, poolDetail } = props;
  const renderError = renderErrorCreatePool;
  // const isDeployed = !!poolDetail?.is_deploy;

  return (
    <>
      <div className={classes.formControl}>
        <label className={classes.formControlLabel}>Token Price At the Time of Giveaway</label>
        <input
          type="text"
          name="token_price"
          defaultValue={poolDetail?.token_price}
          ref={register({})}
          maxLength={255}
          className={classes.formControlInput}
          // disabled={isDeployed}
        />
      </div>
    </>
  );
}

export default TokenPriceGiveaway;
